/** The set with `key` in or out as `present` says; the same set when nothing changes, so a store does not re-render. */
export const withKey = (keys: ReadonlySet<string>, key: string, present: boolean): ReadonlySet<string> => {
    if (keys.has(key) === present) return keys;
    const next = new Set(keys);
    if (present) {
        next.add(key);
    } else {
        next.delete(key);
    }

    return next;
};
